module.exports = __webpack_public_path__ + "static/media/flickeringScreen.12da7012.gif";